import { createActions } from 'reduxsauce';

export const { Types: types, Creators: actions } = createActions({
    // view type
    requestViewType: ['id'],
    viewTypeSucceeded: ['data'],
    viewTypeFailed: ['error'],

    // clear state
    clearTypeViewState: null,
});

export default {
    // view type
    [types.REQUEST_VIEW_TYPE]: (state) => ({
        ...state,
        view: {
            ...state.view,
            loading: true,
            error: null,
        },
    }),
    [types.VIEW_TYPE_SUCCEEDED]: (state, { data }) => ({
        ...state,
        view: {
            ...state.view,
            typeDetails: data,
            loading: false,
        },
    }),
    [types.VIEW_TYPE_FAILED]: (state, { error }) => ({
        ...state,
        view: {
            ...state.view,
            loading: false,
            error,
        },
    }),

    // clear state
    [types.CLEAR_TYPE_VIEW_STATE]: (state) => ({
        ...state,
        view: {
            ...state.view,
            typeDetails: null,
        },
    }),
}
